app-file-store-root-view{flex-grow:1;height:0;overflow:auto;display:flex}app-file-store-root-view .right-side-container app-icon-view{flex-grow:initial}app-file-store-root-view .right-side-container app-icon-view .grid-content{position:initial}
/*# sourceMappingURL=file-store-root-view.component-M3MRXO6L.css.map */
